'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./avatar.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Avatar(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      radius = _ref.radius,
      size = _ref.size,
      src = _ref.src,
      props = _objectWithoutProperties(_ref, ['alt', 'className', 'radius', 'size', 'src']);

  var classes = (0, _classnames2.default)('avatar', 'avatar--radius-' + radius, 'avatar--' + size, className);

  return src ? _react2.default.createElement('img', _extends({ src: src, className: classes, alt: alt, width: size, height: size }, props))
  // ToDo check typography
  : _react2.default.createElement(_icon2.default, _extends({ name: 'product-avatar', className: classes, size: size, style: { color: '#ececec' } }, props));
}

Avatar.propTypes = {
  alt: _propTypes2.default.string,
  className: _propTypes2.default.string,
  radius: _propTypes2.default.oneOf(['small', 'medium', 'full']),
  size: _propTypes2.default.string,
  src: _propTypes2.default.string
};

// TODO get some default image ulr from the API
Avatar.defaultProps = {
  alt: '',
  radius: 'full',
  size: '40'
};

exports.default = Avatar;